import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";

const PaymentCancel = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <div data-testid="payment-cancel-page" className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-brand-light">
      <div className="w-full max-w-md rounded-2xl border border-brand-navy/10 bg-white p-10 text-center">
        <div className="mx-auto h-16 w-16 rounded-full bg-orange-100 flex items-center justify-center text-brand-orange"><XCircle className="h-9 w-9" /></div>
        <h1 className="mt-5 text-2xl font-bold font-heading text-brand-navy">{t("pay.cancelTitle")}</h1>
        <p className="mt-2 text-brand-navy/60">{t("pay.cancelSub")}</p>
        <Button data-testid="cancel-back-cart" onClick={() => navigate("/carrello")} className="mt-6 rounded-full bg-brand-electric hover:bg-brand-electric/90 text-white">{t("pay.backCart")}</Button>
      </div>
    </div>
  );
};

export default PaymentCancel;
